import type { PleaseApiConfig } from '../PleasedApi';
import type { FirebaseSetting } from '../PleasedChat/PleasedChat.types';
import * as oldEnvironment from '@/common/environment';
export interface PleasedSdkConfig extends PleaseApiConfig {
  firebase: Readonly<FirebaseSetting>;
  directLink: boolean;
}

let config: PleasedSdkConfig | null = null;

export function get<K extends keyof PleasedSdkConfig>(key: K): PleasedSdkConfig[K] {
  return config?.[key] as PleasedSdkConfig[K];
}

export function setConfig(env: Partial<PleasedSdkConfig>) {
  if (!config) {
    config = { ...env } as PleasedSdkConfig;
    // return;
  }

  const oldFirebase = oldEnvironment.get('firebase');

  const { firebase = null, url = '', brandCode = '', acceptLanguage = '', token = '', directLink = false } = env;
  if (firebase) {
    config.firebase = firebase;
  } else if (oldFirebase) {
    config.firebase = oldFirebase;
  }

  const oldUrl = oldEnvironment.get('url');
  if (url) {
    config.url = url;
  } else if (oldUrl) {
    config.url = oldUrl;
  }

  brandCode && (config.brandCode = brandCode);
  token && (config.token = token);
  if (token === null) config.token = undefined;

  acceptLanguage && (config.acceptLanguage = acceptLanguage);
  directLink && (config.directLink = directLink);
}
